import { Divider, GKButton, Grid2, StatusField, Typography } from "components";
import {
  ArrowRightIcon,
  CheckIcon,
  HashIcon,
  MfInfoIcon,
  PhoneIcon,
  WarningIcon1,
} from "components/Icons";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const MfOnboardingStatus = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const clientName = searchParams.get("client_name");
  const phone = searchParams.get("phone");
  const clientId = searchParams.get("client_id");
  const token = searchParams.get("token");
  const code = searchParams.get("client_code");
  const basketName = searchParams.get("basket_name");
  const fpReadinessStatus = searchParams.get("fp_readiness_status");

  return (
    <Grid2
      container
      direction="column"
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Grid2 container justifyContent="center" style={{ flex: 1 }}>
        <Grid2
          size={{ xs: 12, md: 6 }}
          py={4}
          px={2}
          sx={{ maxWidth: "580px" }}
        >
          <Grid2 size={12} p={1.5} borderRadius={1.5} bgcolor={"#F8F8F8"}>
            <Typography fontSize={20} fontWeight={700} mb={0.5}>
              {clientName || ""}
            </Typography>

            <Grid2 size={12}>
              <Grid2 container gap={1} alignItems={"center"}>
                <Grid2
                  container
                  gap={1}
                  alignItems={"center"}
                  size={{ xs: 12, md: "auto" }}
                >
                  <PhoneIcon color="var(--grey-500)" />

                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color={"var(--grey-500)"}
                  >
                    Phone No:
                  </Typography>

                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    color={"var(--neutral-700)"}
                  >
                    {phone || ""}
                  </Typography>
                </Grid2>

                <Grid2
                  size={{ xs: 12, md: "auto" }}
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  <Divider orientation="vertical" flexItem />
                </Grid2>

                <Grid2
                  container
                  gap={1}
                  alignItems={"center"}
                  size={{ xs: 12, md: "auto" }}
                >
                  <HashIcon color="(--grey-500)" />

                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color={"var(--grey-500)"}
                  >
                    Client Code:
                  </Typography>

                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    color={"var(--neutral-700)"}
                  >
                    {code || ""}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>

          <Grid2 size={12} mt={4} py={1}>
            <Grid2 container alignItems={"center"} gap={1}>
              <CheckIcon />

              <Typography
                width={"134px"}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                Basket Name:
              </Typography>

              <Typography
                fontSize={12}
                fontWeight={600}
                color="var(--neutral-700)"
              >
                {basketName || ""}
              </Typography>
            </Grid2>
          </Grid2>

          <Divider style={{ borderStyle: "dashed", borderColor: "#ccc" }} />

          <Grid2 size={12} py={1}>
            <Grid2 container alignItems={"center"} gap={1}>
              <WarningIcon1 />

              <Typography
                width={"134px"}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                MF Investor Readiness:
              </Typography>

              <StatusField statusString={fpReadinessStatus || "Unavailable"} />
            </Grid2>
          </Grid2>

          <Grid2
            size={12}
            mt={4}
            py={3}
            px={2}
            style={{
              backgroundColor: "var(--yellow-100)",
              borderRadius: "8px",
            }}
          >
            <Grid2
              container
              justifyContent={"center"}
              alignItems={"center"}
              mb={2}
            >
              <MfInfoIcon />
            </Grid2>

            <Typography
              fontSize={16}
              fontWeight={700}
              color="var(--grey-900)"
              textAlign={"center"}
            >
              Investing in Mutual Funds requires KYC
            </Typography>

            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--grey-500)"
              textAlign={"center"}
              mt={1}
            >
              It seems your KYC process for Mutual Fund investments is still
              incomplete. Please complete it to continue making transactions.
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>

      {/* Footer */}
      <Grid2
        container
        position={"sticky"}
        bottom={0}
        bgcolor={"#fff"}
        size={12}
        zIndex={99}
        display={"flex"}
        justifyContent={"center"}
        gap={1}
        alignItems={"center"}
        p={2}
        borderTop={"1px solid var(--neutral-100)"}
      >
        <Grid2
          size={{ xs: 12, md: 6 }}
          display="flex"
          justifyContent="end"
          alignItems="center"
          gap={2}
          sx={{ maxWidth: "580px", width: "100%" }}
        >
          <GKButton
            variant="contained"
            type="submit"
            loading={isLoading}
            endIcon={<ArrowRightIcon />}
            onClick={() => {
              setIsLoading(true);
              navigate(
                `/investor/mf-kyc-verification/${clientId}?token=${token}&client_id=${clientId}`,
              );
            }}
          >
            Complete KYC
          </GKButton>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default MfOnboardingStatus;
